import { render, staticRenderFns } from "./TiposPrecios.view.vue?vue&type=template&id=7943b04c&"
import script from "./TiposPrecios.view.vue?vue&type=script&lang=js&"
export * from "./TiposPrecios.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports